export default __webpack_public_path__ + "static/landing_page_Img-ffdcbee244c6577440955975810a1e49.png";